import React, { useRef, useEffect, ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import { useRecoilState } from 'recoil'

import { bookmarkAreaOpenAtom } from 'atoms/bookmark/Bookmark'
import DescriptionAreaComponent from 'components/description/DescriptionAreaComponent'
import { ReactComponent as BookmarkOpenFloatingButton } from 'resource/bookmark/bookmark_open_floating_button.svg'

type ContentFrameComponentProps = {
  children?: ReactNode
}

const ContentFrameComponent: React.FC<ContentFrameComponentProps> = ({ children }) => {
  const location = useLocation()
  const [bookmarkAreaOpen, setBookmarkAreaOpen] = useRecoilState(bookmarkAreaOpenAtom)
  const contentTextAreaRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const current = contentTextAreaRef?.current
    if (!current) {
      return
    }

    current.scrollTo(0, 0)
  }, [location])

  useEffect(() => {
    const pathnames = location.pathname.split('/')
    const itemName = decodeURIComponent(pathnames[pathnames.length - 1])
    const element = document.getElementById(itemName)
    if (element) {
      setTimeout(() => {
        const current = contentTextAreaRef?.current
        if (!current) {
          return
        }
        current.scrollTo({ top: element.getBoundingClientRect().top - 100, behavior: 'smooth' })
      }, 500)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
  }, [location])

  const handleBookmarkAreaOpen = () => {
    setBookmarkAreaOpen(true)
  }
  const makeBookmarkOpenFloatingButton = () => {
    return (
      <div className="BookmarkOpenFloatingButtonFrame" onClick={() => handleBookmarkAreaOpen()}>
        <div className="BookmarkOpenFloatingButton">
          <BookmarkOpenFloatingButton />
        </div>
        <div className="BookmarkOpenFloatingText">북마크</div>
      </div>
    )
  }

  const makeContentFrame = () => {
    if (bookmarkAreaOpen) {
      return (
        <div className="ContentFrame">
          <div className="ContentTextArea" ref={contentTextAreaRef}>
            <DescriptionAreaComponent />
          </div>
          {children}
        </div>
      )
    }

    return (
      <div className="ContentFrame">
        <div className="ContentTextArea" ref={contentTextAreaRef}>
          <DescriptionAreaComponent />
        </div>
        {makeBookmarkOpenFloatingButton()}
      </div>
    )
  }

  return makeContentFrame()
}
export default ContentFrameComponent
